import { eventQBus, Topics } from "../../types/EventQBus";
import { HistoryMergeType, HistoryPushType, HistoryShiftType } from "../../types/EventHistory";

let lastRelativeLocationWithoutHash: string = "";

/**
 *
 */
function isEphemeral() {
  const { ephemeral = false } = window.history.state || {};
  return ephemeral;
}

/**
 *
 *
 *
 */
function mergeEventState<Topic extends keyof Topics>(topic: Topic | undefined, data: Topics[Topic][0], url: string) {
  const { events: currentEvents = {}, ...currentData } = window.history.state || {};
  const events = topic ? { [topic]: data } : {};
  window.history.replaceState(
    {
      ...currentData,
      events: { ...currentEvents, ...events },
    },
    "",
    url,
  );
}

/**
 *
 *
 *
 *
 *
 */
function pushEventState<Topic extends keyof Topics>(
  topic: Topic | undefined,
  ephemeral: boolean,
  data: Topics[Topic][0],
  url: string,
) {
  const events = topic ? { [topic]: data } : {};
  const state = { ephemeral: ephemeral, events };

  if (isEphemeral()) {
    window.history.replaceState(state, "", url);
  } else {
    window.history.pushState(state, "", url);
  }
}

/**
 *
 *
 *
 *
 */
function shiftEventState(force: boolean) {
  if (force || isEphemeral()) {
    window.removeEventListener("popstate", onPopState);
    window.addEventListener("popstate", onShiftState);
    history.back();
  }
}

function updateRelativeLocationWithoutHash(): void {
  lastRelativeLocationWithoutHash = getRelativeLocationWithoutHash();
}

/**
 *
 */
function onPopState(event: PopStateEvent) {
  const events = (event.state && event.state.events) || {};

  if (lastRelativeLocationWithoutHash === getRelativeLocationWithoutHash()) {
    /*                                                                   */
    /*                                                                                                               */
    return;
  }

  for (const topic in events) {
    if (Object.hasOwn(events, topic)) {
      eventQBus.emit(topic as keyof Topics, events[topic]);
    }
  }
}

/**
 *
 *
 *
 *
 *
 */
function onShiftState() {
  window.removeEventListener("popstate", onShiftState);
  window.addEventListener("popstate", onPopState);
}

function getRelativeLocationWithoutHash() {
  const { pathname = "/", search = "" } = window.location;
  return pathname + search;
}

let initialized = false;

/**
 *
 */
export function initEventHistory() {
  if (initialized) {
    return;
  }

  initialized = true;
  lastRelativeLocationWithoutHash = getRelativeLocationWithoutHash();

  eventQBus.on("ftfind.history.push", (payload: HistoryPushType) => {
    const { topic, data, url, ephemeral = false } = payload || {};
    pushEventState(topic, ephemeral, data, url);
  });

  eventQBus.on("ftfind.history.merge", (payload: HistoryMergeType) => {
    const { topic, data, url } = payload || {};
    mergeEventState(topic, data, url);
  });

  eventQBus.on("ftfind.history.shift", (payload: HistoryShiftType) => {
    /*                                                         */
    /*                                                    */
    const { force = true } = payload || {};
    shiftEventState(force);
  });

  eventQBus.on("ftfind.tilelist.loaded", () => {
    updateRelativeLocationWithoutHash();
  });

  window.addEventListener("popstate", onPopState);
}
